(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mq = window.matchMedia('(max-width: 749px)');
    const selector = '.footer-content .email-signup__input[type="email"]';

    const syncFooterEmailPlaceholder = () => {
      document.querySelectorAll(selector).forEach((input) => {
        if (!input.dataset.jeloDesktopPlaceholder) {
          input.dataset.jeloDesktopPlaceholder = input.getAttribute('placeholder') || '';
        }
        input.setAttribute(
          'placeholder',
          mq.matches ? 'Gmail' : input.dataset.jeloDesktopPlaceholder
        );
      });
    };

    syncFooterEmailPlaceholder();

    if (mq.addEventListener) {
      mq.addEventListener('change', syncFooterEmailPlaceholder);
    }

    document.addEventListener('shopify:section:load', syncFooterEmailPlaceholder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
